<template>
  <div>
    <button
      type="button"
      :class="['btn', 'btnRate', $i18n.locale === 'en' ? 'pb-lg-5 pb-md-5 pt-md-2 pt-0' : null]"
      data-toggle="modal"
      data-target="#modalRateUs"
    >
      {{ $t("rate-us") }}
    </button>
    <div id="modalRateUs" class="modal fade seferModal modalWarning" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable scrollbar">
        <div class="modal-content">
          <div class="modal-header">
            <div class="row no-gutters">
              <div class="col-12">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="col-auto text-center">
                <img src="/src/images/tcdd-logo.png" class="img-fluid imgLogo" alt="tcdd-logo" loading="lazy" />
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="row justify-content-center">
              <div class="col-12">
                <h5 class="textHead">
                  {{ $t("rate-us-message") }}
                </h5>
                <p class="text font-weight-normal mb-sm-4 mb-2">
                  {{ $t("rate-us-message-v2") }}
                </p>
              </div>
              <div class="col-12">
                <p class="text mb-2">
                  {{ $t("rate-us-message-v3") }}
                </p>
                <div class="starArea">
                  <button type="button" class="btn btnStar" :class="ratingValue >= 1 ? 'active' : null" @click="ratingValue = 1"></button>
                  <button type="button" class="btn btnStar" :class="ratingValue >= 2 ? 'active' : null" @click="ratingValue = 2"></button>
                  <button type="button" class="btn btnStar" :class="ratingValue >= 3 ? 'active' : null" @click="ratingValue = 3"></button>
                  <button type="button" class="btn btnStar" :class="ratingValue >= 4 ? 'active' : null" @click="ratingValue = 4"></button>
                  <button type="button" class="btn btnStar" :class="ratingValue === 5 ? 'active' : null" @click="ratingValue = 5"></button>
                </div>
                <p v-if="ratingValue > 0" class="text font-weight-normal mb-4 font-italic">
                  {{ $t("rate-us-message-v4") }}
                </p>
              </div>
              <div class="col-12">
                <div class="form-group">
                  <label class="text">{{ $t("rate-us-message-v5") }}</label>
                  <textarea v-model="commentArea" class="form-control" rows="2" :placeholder="$t('rate-us-message-v6')"></textarea>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">{{ $t("rate-us-give-up") }}</button>
            <button
              class="btn btn-primary d-flex justify-content-center align-items-center"
              :type="'submit'"
              :disabled="sendCommentLoading"
              @click="sendComment()"
            >
              <template v-if="sendCommentLoading">
                <b-spinner small class="mr-1" />
                <span class="sr-only">Loading...</span>
              </template>
              {{ $t("rate-us-send") }}
            </button>
            <loading :active.sync="sendCommentLoading" :is-full-page="false" class="btnLoading" />
          </div>
        </div>
      </div>
      <base-alert />
    </div>
  </div>
</template>

<script>
import ServiceResponseHelper from "../mixins/serviceResponseHelper";
import Loading from "vue-loading-overlay";
import BaseAlert from "./element/BaseAlert.vue";
import Vue from "vue";
import { SpinnerPlugin } from "bootstrap-vue";
Vue.use(SpinnerPlugin);

export default {
  name: "RateUsComponent",
  components: { Loading, BaseAlert },
  mixins: [ServiceResponseHelper],
  data() {
    return {
      commentArea: null,
      ratingValue: 0,
      sendCommentLoading: false,
    };
  },
  methods: {
    sendComment() {
      if (this.ratingValue === 0) return;
      this.sendCommentLoading = true;
      let request = {};
      request.salesChannelId = 2;
      request.score = this.ratingValue.toString();
      request.comment = this.commentArea;
      this.$store
        .dispatch("evaluations", request)
        .then((response) => {
          $(".modal").modal("hide");
          this.callAlert(4, this.$t("rate-us-message-success"), "success", this.$t("successful-transaction"));
        })
        .catch((err) => {
          this.callAlert(4, this.$t("rate-us-message-error"), "warning", this.$t("failed-transaction"));
        })
        .finally(() => {
          this.sendCommentLoading = false;
          this.ratingValue = 0;
          this.commentArea = null;
        });
    },
  },
};
</script>

<style scoped>
.btnRate {
  z-index: 3;
}
</style>
